import React from "react";
import { useNavigate } from "react-router-dom";
import { Stack, Box, Typography, Button, Card, CardContent } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";

/** Stripe Checkout cancel landing — user backed out without subscribing. */
export const BillingCancelPage = () => {
  const navigate = useNavigate();
  return (
    <Stack
      spacing={3}
      sx={{
        p: { xs: 2, md: 6 },
        backgroundColor: "#f8fafc",
        height: "calc(100vh - 80px)",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Card variant="outlined" sx={{ borderRadius: 3, maxWidth: 520 }}>
        <CardContent sx={{ p: 4, textAlign: "center" }}>
          <CancelIcon sx={{ fontSize: 64, color: "#64748b" }} />
          <Typography variant="h4" sx={{ fontWeight: 700, mt: 2, mb: 1 }}>
            Checkout cancelled.
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            No charge was made. You can pick a plan again any time from the billing page.
          </Typography>
          <Box sx={{ display: "flex", gap: 1, justifyContent: "center", flexWrap: "wrap" }}>
            <Button
              variant="contained"
              sx={{ backgroundColor: "#1F4E78" }}
              onClick={() => navigate("/billing")}
            >
              Pick a plan
            </Button>
            <Button variant="outlined" onClick={() => navigate("/")}>
              Back to dashboard
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Stack>
  );
};

export default BillingCancelPage;
